import { getStorage } from "@/helpers/LocalStorage";

export default class UserController {
    get photo() { return getStorage('image'); }
    get role() { return getStorage('role'); }
    get id() { return getStorage('id'); }
}
